/**
 * Shared condition document filename builder.
 *
 * Used by ApprovalLetterTab, ConditionsPortal, and InternalConditionsPortal
 * to generate consistent suggested filenames for condition template downloads.
 */
export function buildConditionFilename(
  templateName: string,
  loanNumber: string,
  pairLabel?: string
): string {
  const sanitized = templateName.replace(/[^a-zA-Z0-9]/g, '_').substring(0, 50);
  const loan = loanNumber || 'loan';
  const pairSuffix = pairLabel
    ? `_${pairLabel.replace(/[^a-zA-Z0-9]/g, '_').substring(0, 30)}`
    : '';
  return `${sanitized}_${loan}${pairSuffix}.pdf`;
}
